// Basic
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import actionsEnvelopes from '../../api/actionsEnvelopes';
import useRootOrganizationStore from '@/app/store/rootOrganization';
import useEnvelopesStore from '@/app/store/modules/envelopes';
// Component
import DataTable from '@/common-utils/components/renders/dataTable/DataTable';
// Columns
import { columnsDownloadCodes, columnsDownloadCodesId } from './columnsDef/columnsDownloadCodes';
// Common
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import mergeQuery from '@/common-utils/components/renders/dataTable/utils/mergeQuery';

/**
 * @param root0
 * @param root0.customQuery
 * @param root0.singleSelection
 * @param root0.rowsSelected
 * @param root0.setRowsSelected
 * @param root0.pageActions
 * @param root0.filtersEventName
 *@returns {JSX} DownloadCodesTable
 */
function DownloadCodesTable({
    customQuery = {},
    singleSelection = false,
    rowsSelected = undefined,
    setRowsSelected = undefined,
    pageActions = undefined,
    filtersEventName
}) {
    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);
    const { refetchDownloadCodes: refetchFromStore, storeRefetchDownloadCodes, queryDownloadCodes: queryStored, storeQueryDownloadCodes } = useEnvelopesStore();

    // Constants
    const initialQuery = getInitialQuery(customQuery);
    const selectionMode = !!(rowsSelected && setRowsSelected);

    // State
    const [query, setQuery] = useState(mergeQuery(initialQuery, queryStored));
    const [launchRefetch, setLaunchRefetch] = useState(true);

    // Api Calls
    const { data, isFetching, refetch } = actionsEnvelopes.getDownloadCodes({ query }, false);

    // Hooks
    useEffect(() => {
        if (rootOrganization && (launchRefetch || refetchFromStore)) {
            refetch();
            setLaunchRefetch(false);
            storeRefetchDownloadCodes(false);
        }
    }, [query, launchRefetch, refetchFromStore]);

    // Constants
    const allColumns = columnsDownloadCodes({
        query,
        setQuery,
        queryStored,
        storeQueryDownloadCodes,
        setLaunchRefetch,
        selectionMode,
        singleSelection,
        filtersEventName
    });

    return (
        <DataTable
            filtersEventName={filtersEventName}
            columns={allColumns}
            data={data}
            dataFetchingIsLoading={isFetching}
            columnsId={columnsDownloadCodesId}
            initialQuery={initialQuery}
            query={query}
            setQuery={setQuery}
            queryStored={queryStored}
            storeQuery={storeQueryDownloadCodes}
            setLaunchRefetch={setLaunchRefetch}

            selectionMode={selectionMode}
            singleSelection={singleSelection}
            rowsSelected={rowsSelected}
            setRowsSelected={setRowsSelected}

            pageActions={pageActions}
        />
    );
}

DownloadCodesTable.propTypes = {
    customQuery: PropTypes.object,
    singleSelection: PropTypes.bool,
    rowsSelected: PropTypes.object,
    setRowsSelected: PropTypes.func,
    pageActions: PropTypes.node,
    filtersEventName: PropTypes.string
};

export default DownloadCodesTable;